import * as React from "react";
import type { SVGProps } from "react";
const SvgHash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M19.2 15.6H4.8m14.4-7.2H4.8m2.4 10.8L9.6 4.8m4.8 14.4 2.4-14.4"
    />
  </svg>
);
export default SvgHash02;
